import { captureException } from '@sentry/react';
import { capacitorSecureStorageService } from 'gcs-common/helper/capacitor-secure-storage-service';
import { LEGACY_EVENTS } from '../../../config/googleAnalyticsLegacyConfig';
import { SELECTED_USER, USERS } from '../../../constants/debugUserSwitcherConstants';
import { clearLocalStorageExcept } from '../../../helper/localStorageHelper';
import { trackGALegacyEvent } from '../../googleAnalytics/googleAnalyticsThunks';
import { resetOfflineQueueState } from '../../offline/offlineActions';
import { clearStore } from '../../store/storeActions';

export const clearPersistenceWhiteList = ['persistence'];

const logoutEffect =
  () =>
  async (dispatch, _getState, { blobStorageClient, persistenceStorageEngine }) => {
    dispatch(trackGALegacyEvent(LEGACY_EVENTS.LOGOUT()));

    try {
      // TODO: unregister push
      // biome-ignore lint/correctness/noUnreachable: <explanation>
    } catch (e) {
      captureException(e);
    }

    dispatch(resetOfflineQueueState());
    dispatch(clearStore());

    if ('clearAppBadge' in navigator) {
      navigator.clearAppBadge();
    }

    try {
      // because it is not guaranteed that the storage was cleared with the clearStore
      // (persisting in redux-persist works asynchronously after a state update)
      await persistenceStorageEngine?.clear?.({ whitelist: clearPersistenceWhiteList });
      clearLocalStorageExcept([
        SELECTED_USER,
        USERS,
        'debugAppTheme',
        'uc_ui_version',
        'uc_user_interaction',
        'uc_settings',
      ]);
      sessionStorage?.clear?.();
      await blobStorageClient?.clear?.();
    } catch (e) {
      // Not good but should not keep the logout from happening
      captureException(e);
    }

    capacitorSecureStorageService.removeSessionRefreshToken();
  };

export default logoutEffect;
